export const FUEL_TYPES_IDS = {
  GASOLINE: '2',
  ELECTRIC: '3'
}

export const FUEL_TYPES = {
  [FUEL_TYPES_IDS.GASOLINE]: {
    id: FUEL_TYPES_IDS.GASOLINE,
    name: 'SEARCH_BOX_SELECT_FUEL_TYPE_GASOLINE'
  },
  [FUEL_TYPES_IDS.ELECTRIC]: {
    id: FUEL_TYPES_IDS.ELECTRIC,
    name: 'SEARCH_BOX_SELECT_FUEL_TYPE_ELECTRIC'
  }
}
